import { render, staticRenderFns } from "./RecoverPhoneVerify.vue?vue&type=template&id=342ab272&scoped=true&"
import script from "./RecoverPhoneVerify.vue?vue&type=script&lang=js&"
export * from "./RecoverPhoneVerify.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPhoneVerify.vue?vue&type=style&index=0&id=342ab272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342ab272",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VFlex,
  VForm,
  VLayout,
  VTextField,
})
